<template>
    <div class="sidenav-inner" :class="{ 'py-1': orientation !== 'horizontal' }"  v-if="currentUser != '' && currentUser.role[0] == 'branch_admin_kabupaten'">
        <sidenav-router-link icon="ion ion-md-speedometer" to="/app"   :exact="true">Dashboard</sidenav-router-link>
        <!-- <sidenav-router-link icon="ion ion-md-boat" to="/app/shipping" :exact="true">Shipping Alkes Interim</sidenav-router-link> -->
        <sidenav-router-link icon="fad fa-truck-loading" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);" to="/app/shipping/pesk/interim" :exact="true">Shipping Pesk Interim</sidenav-router-link>

        <sidenav-router-link icon="fad fa-truck-container" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);" to="/app/shipping/alkes/interim" :exact="true">Shipping Alkes Interim</sidenav-router-link>

        <sidenav-menu icon="fad fa-layer-group" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
          <template slot="link-text">Master Data</template>
          <sidenav-router-link to="/app/masterdata/user-management" :exact="true">User Management</sidenav-router-link>
          <sidenav-router-link to="/app/masterwadah" :exact="true">Borang Master Wadah</sidenav-router-link>
        </sidenav-menu>

        <sidenav-menu icon="fad fa-warehouse" style="--fa-secondary-opacity: 1.0; --fa-primary-color: var(--c-cyan); --fa-secondary-color: var(--c-purple);">
      <template slot="link-text">WMS</template>
      <sidenav-router-link to="/app/wms/stock/provinsi/storage" :exact="true">Stock take (Stock Opname)</sidenav-router-link>
        
        <sidenav-menu>
          <template slot="link-text">Reporting</template>
            <sidenav-router-link to="/app/wms/reporting/provinsi/alkes/storage" :exact="true">Alkes</sidenav-router-link>
            <sidenav-router-link to="/app/wms/reporting/provinsi/pesk/storage" :exact="true">Pesk</sidenav-router-link>
        </sidenav-menu>

      <sidenav-router-link to="/app/wms/dispatching" :exact="true">
        Dispatching
      </sidenav-router-link>
      </sidenav-menu>

    </div>
</template>
<script>
import { Sidenav, SidenavLink, SidenavRouterLink, SidenavMenu, SidenavHeader, SidenavBlock, SidenavDivider } from '@/vendor/libs/sidenav'
export default {
    data: () => ({

    }),
    components:{
        Sidenav,
        SidenavLink,
        SidenavRouterLink,
        SidenavMenu,
        SidenavHeader,
        SidenavBlock,
        SidenavDivider,
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
    },
    props: {
    orientation: {
      type: String,
      default: 'vertical'
    }
    },
    methods: {
    isMenuActive (url) {
      return this.$route.path.indexOf(url) === 0
    },

    isMenuOpen (url) {
      return this.$route.path.indexOf(url) === 0 && this.orientation !== 'horizontal'
    },

    toggleSidenav () {
      this.layoutHelpers.toggleCollapsed()
    }
  }


}
</script>
